module.exports = __webpack_public_path__ + "static/media/insurance-requests.a3d4f726.svg";